module.exports = __webpack_public_path__ + "img/image33.594f8611.png";